// Cena 10 — Configurações + encerramento (áudio ~22s)
// Um toggle fictício demonstra o ajuste da plataforma; depois a despedida
// aponta o caminho: a tela de Conexões, onde o WhatsApp é conectado.
const MAIN = "[data-tour='main-content']";
const CONNECTIONS = "[data-tour='menu-connections']";
const TOGGLE = "[data-demo='toggle']";

export default async function settings(ctx) {
	await ctx.wait(1100);

	// "nas Configurações você ajusta o comportamento da plataforma…"
	const row = ctx.mount("settingRow", MAIN, {
		label: "Criação automática de tickets",
		on: false,
		style: { position: "absolute", left: 24, top: 120, width: 440 },
	});
	await ctx.waitFor(TOGGLE);
	await ctx.wait(2500);

	// "…como a criação automática de tickets" — o cursor vai ao interruptor
	await ctx.cursorTo(TOGGLE, { duration: 1000 });
	await ctx.wait(1500);

	// liga o toggle
	await ctx.click(TOGGLE);
	ctx.update(row, { on: true });
	await ctx.wait(2100);

	// "E… prontinho! Você já conhece o Flytec!"
	ctx.mount("toast", MAIN, {
		icon: "🎉",
		text: "Tutorial completo! Bora conectar seu WhatsApp",
	});
	await ctx.wait(2800);

	// "Eu te espero na tela de Conexões" — spotlight e cursor passeiam até o menu
	await ctx.waitFor(CONNECTIONS);
	ctx.spotlight(CONNECTIONS);
	await ctx.cursorTo(CONNECTIONS, { duration: 1700 });
	await ctx.wait(3200);

	ctx.spotlight(null);

	// "Bom trabalho… e ótimas vendas!" — cursor descansa em Conexões,
	// com o toast de despedida ainda em cena como estado final.
	await ctx.wait(3400);
}
